import {
  Alert,
  Backdrop,
  Card,
  CircularProgress,
  Icon,
  IconButton,
  ListItem,
  Snackbar,
} from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function DawActivationsPage() {
  const pageTitle = `Display & Win Activations`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [campaigns, setCampaigns] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/daw.json")
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaigns(result.data.data.campaigns);
            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {pageLoaded && (
        <MDBox mt={1} mb={5}>
          {campaigns.length > 0 ? (
            <MDBox>
              <MDBox display="flex" justifyContent="space-between" px={1} mb={-1}>
                <MDBox>
                  <Icon>category</Icon>
                </MDBox>
                <MDBox>
                  <MDTypography variant="h6" fontWeight="regular" mb={3}>
                    Activations
                  </MDTypography>
                </MDBox>
              </MDBox>
              {campaigns.map((activation) => (
                <Card>
                  <MDBox p={2}>
                    <ListItem key={activation.reference}>
                      <MDBox
                        width="100%"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        onClick={() =>
                          navigate(`/activations/display-win/${activation.reference}`)
                        }
                      >
                        <MDBox>
                          <MDTypography fontSize={14}>
                            {activation.title}
                          </MDTypography>
                          <MDTypography fontSize={12} color="text.secondary">
                            {activation.account.name}
                          </MDTypography>
                        </MDBox>

                        <IconButton size="small" color="primary">
                          <Icon>east</Icon>
                        </IconButton>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                </Card>
              ))}
            </MDBox>
          ) : (
            <MDBox>
              <MDTypography>
                <Icon>warning</Icon>
              </MDTypography>
              <MDTypography variant="subtitle2" fontSize={13}>
                No activations available for you.
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default DawActivationsPage;
